import { jobChangeTagLabelParser } from '../components/filter-tags/utils';
import { FilterCategory, SearchFilterBase, SearchFilterType } from '../types';

export default function jobChangeFilterConfig(): SearchFilterBase {
  return {
    id: 'Saved Contact Updates',
    name: 'Saved Contact Updates',
    icon: 'job-change',
    index: 15,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.CONTACT_DATA],
    utils: {
      tags: {
        config: {
          showAsCard: true,
          tagsCardTitle: 'Contact with Job Changes',
        },
      },
    },
    pinned: true,
    layer: 3,
    items: [
      {
        type: SearchFilterType.CHECK_BOX,
        icon: undefined,
        index: 0,
        field: 'contact_job_change',
        key: 'contact_job_change',
        name: '',
        layer: 4,
        nested: false,
        config: { labelKey: 'label', valueKey: 'value' },
        metadata: {
          color: 'primary',
          styles: {
            sx: {
              paddingLeft: 1,
            },
          },
        },
        utils: { tags: { labelFormatter: jobChangeTagLabelParser } },
        options: [
          {
            type: 'STRING',
            value: 'true',
            label: 'Contact with Job Changes',
            icon: null,
            index: 1,
          },
        ],
      },
    ],
  };
}
